const { env } = window;

export const identityServer = env.IDENTITY_HOST;

export const accountServer = '/accounts/profile-management/accounts';

export const profileServer = '/accounts/profile-management/users';
export const publicProfileServer = '/accounts/public/profile-management/users';

export const imageServer = '/accounts/profile-management/images';

export const walletServer = '/wallet';

export const paymentServer = '/accounts/partner/payments';
export const transactionServer = '/accounts';

export const stationServer = '/core/partner/station';

export const geofenceServer = '/core/partner/geofence';

export const stationsServer = '/core/partner/stations';

export const partnerServer = '/core/partner';

export const configServer = '/config';

// Global search is disabled: the left-nav Search panel was not useful to operators.
// Code is kept commented so it can be restored. These two URLs were used only by that panel.
// export const globalSearchServer = '/core/partner/searches/global';
//
// export const recentSearchServer = '/core/searches/recent';

export const dashboardServer = '/accounts/partner/dashboard';

export const analyticsServer = '/tlog/partner/analytics';

export const partnerTransactionsServer = '/tlog/partner/transactions';

export const catalogServer = '/tlog/partner/product-catalog';

export const memberServer = '/accounts/profile-management/members';

export const notificationServer = '/notifications';

export const supportServer = '/accounts/partner/notifications/support';
